import React from 'react';
import Product from './Product';

interface ProductData {
  id: number;
  name: string;
  price: string;
  savings_price?: string;
  features?: string;
  trial?: boolean;
  product_name: string;
  tagline: string;
  savings: string;
  product_type?: string;
  stripe_plan: string;
}

interface BillingProductsProductsProps {
  products: ProductData[];
  className?: string;
  productClassName?: string;
  form_authenticity_token?: string;
  user_signed_in?: boolean;
}

/**
 * BillingProductsProducts Component
 * This component is used for displaying staffing plans on the pricing page
 * It matches the original functionality from master branch
 */
const BillingProductsProducts: React.FC<BillingProductsProductsProps> = ({
  products,
  className = '',
  productClassName = '',
  form_authenticity_token,
  user_signed_in = false
}) => {
  if (!products || products.length === 0) {
    return (
      <div className="no-products-available">
        <div className="empty-state text-center">
          <i className="fa fa-briefcase fa-3x text-muted mb-3"></i>
          <h3>No Products Available</h3>
          <p>There are currently no staffing products available.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      {products.map((product, index) => (
        <div key={product.id || index} className={productClassName}>
          <Product
            {...product}
            form_authenticity_token={form_authenticity_token}
            user_signed_in={user_signed_in}
          />
        </div>
      ))}
    </div>
  );
};

export default BillingProductsProducts;
